import "../chunk-BBZEL7EG.js";
var OnRampProvider = /* @__PURE__ */ ((OnRampProvider2) => {
  OnRampProvider2["RAMP"] = "RAMP";
  OnRampProvider2["STRIPE"] = "STRIPE";
  OnRampProvider2["MOONPAY"] = "MOONPAY";
  return OnRampProvider2;
})(OnRampProvider || {});
var OnRampAsset = /* @__PURE__ */ ((OnRampAsset2) => {
  OnRampAsset2["ETHEREUM"] = "ETHEREUM";
  OnRampAsset2["USDC"] = "USDC";
  OnRampAsset2["TETHER"] = "TETHER";
  OnRampAsset2["POLYGON"] = "POLYGON";
  OnRampAsset2["SOLANA"] = "SOLANA";
  OnRampAsset2["ATOM"] = "ATOM";
  OnRampAsset2["CELO"] = "CELO";
  OnRampAsset2["CUSD"] = "CUSD";
  OnRampAsset2["CEUR"] = "CEUR";
  OnRampAsset2["CREAL"] = "CREAL";
  return OnRampAsset2;
})(OnRampAsset || {});
var OnRampPurchaseStatus = /* @__PURE__ */ ((OnRampPurchaseStatus2) => {
  OnRampPurchaseStatus2["INITIATED"] = "INITIATED";
  OnRampPurchaseStatus2["FINISHED"] = "FINISHED";
  OnRampPurchaseStatus2["CANCELLED"] = "CANCELLED";
  return OnRampPurchaseStatus2;
})(OnRampPurchaseStatus || {});
var OnRampPurchaseType = /* @__PURE__ */ ((OnRampPurchaseType2) => {
  OnRampPurchaseType2["BUY"] = "BUY";
  OnRampPurchaseType2["SELL"] = "SELL";
  return OnRampPurchaseType2;
})(OnRampPurchaseType || {});
export {
  OnRampAsset,
  OnRampProvider,
  OnRampPurchaseStatus,
  OnRampPurchaseType
};
